import React from 'react';
import {Alert} from 'src/design/atoms/Alert';
import {Box} from 'src/design/atoms/Box';
import {Center} from 'src/design/atoms/Center';
import {Stack} from 'src/design/atoms/Stack';
import {Text} from 'src/design/atoms/Text';
import {SkillMatrixStatusEnum} from 'src/api/ProactApiClient';
import {SectionCard} from 'src/design/atoms/SectionCard';
import {Spinner} from 'src/design/atoms/Spinner';
import {useGetMySkillsQuery} from 'src/redux/queries/skillSignOff';
import {parseErrorMessage} from 'src/shared/utils/parseErrorMessage';
import {SkillItem} from './SkillItem';

const EXPIRING_WINDOW_DAYS = 30;
const TOP_N = 5;

export const MySkillsCard: React.FC = () => {
  const {
    data: mySkills,
    isLoading,
    isError,
    error,
  } = useGetMySkillsQuery({expiringWithinDays: EXPIRING_WINDOW_DAYS});

  const skills = (mySkills ?? [])
    .filter(skill => skill.status !== SkillMatrixStatusEnum.Never)
    .slice(0, TOP_N);

  return (
    <SectionCard title="My Skills" h="100%">
      <Box px="xs" py="xs">
        {isError ? (
          <Alert color="red">{parseErrorMessage(error)}</Alert>
        ) : isLoading ? (
          <Center py="lg">
            <Spinner loadingText="Loading your skills..." />
          </Center>
        ) : skills.length === 0 ? (
          <Center py="lg">
            <Text size="sm" c="dimmed">
              No skills have been defined for this instance yet.
            </Text>
          </Center>
        ) : (
          <Stack gap={0}>
            {skills.map((skill, index) => (
              <SkillItem
                key={skill.skillId}
                skill={skill}
                isLast={index === skills.length - 1}
              />
            ))}
          </Stack>
        )}
      </Box>
    </SectionCard>
  );
};
